import { useEffect, useState } from 'react';

/** The width at which checkout splits into two columns. Matches the `1001px` breakpoint in the SCSS. */
const WIDE_LAYOUT_QUERY = '(min-width: 1001px)';

function matchesWideLayout() {
  return typeof window !== 'undefined' && !!window.matchMedia?.(WIDE_LAYOUT_QUERY).matches;
}

/**
 * Whether checkout is showing its two-column desktop layout, kept in step with the window as it is
 * resized. The layout itself is CSS; this exists only for what CSS cannot do, which is moving the pay
 * button into the summary column.
 */
export function useWideLayout() {
  const [wide, setWide] = useState(matchesWideLayout);

  useEffect(() => {
    const query = window.matchMedia?.(WIDE_LAYOUT_QUERY);
    if (!query) {
      return;
    }
    const update = () => setWide(query.matches);
    update();
    query.addEventListener('change', update);
    return () => query.removeEventListener('change', update);
  }, []);

  return wide;
}
